// @flow

import React, { useState } from 'react';
import classNames from 'classnames';
import { log } from '../../utils/jsUtils';
import red from '@mui/material/colors/red';

import Button from '@mui/material/Button';
import ToggleButton from '@mui/lab/ToggleButton';
import Input from '@mui/material/Input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import BroadcastIcon from '@mui/icons-material/TextsmsOutlined';

import withStyles from '../../utils/withStyles';
import styles from './Styles/AddPropertyDialog.Style';
import type { Unit } from '../../services/SPBackend';

type Props = {
  classes: Object,
  setOpen: Function,
  open: boolean,
  actionConfirm: Function,
  unit: Unit
}

const RemoveUnit = (props: Props) => {
  const {
    classes,
    setOpen,
    open,
    actionConfirm,
    unit
  } = props;

  return (
    <div>
    {
      unit !== null
      ? <Dialog
          aria-labelledby='form-add-Unit'
          onClose={() => setOpen(false)}
          open={open}
        >
          <DialogTitle id='form-dialog-title'>
          {'HEADS UP!'}
          </DialogTitle>
          <DialogContent className={classNames(classes.grow, classes.flexContainer)}>
            <DialogContentText>
              {'You are about to remove this Unit from your account:'}<br />
              <b style={{color: red[600]}}>Apt {unit.Apt}, floor {unit.Floor}</b><br /><br />
              {'Are you sure?'}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color='primary'
              onClick={() => setOpen(false)}
            >
              {'Cancel'}
              </Button>
            <Button 
              color='primary'
              onClick={() => { actionConfirm(); setOpen(false); }}
              variant='contained'
            >
              {'Remove'}
              </Button>
          </DialogActions>
        </Dialog>
      : null
    }
    </div>
  );
};

export default withStyles(styles)(RemoveUnit);